import React, { useContext, useMemo } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { FormattedMessage } from "react-intl";
import UserContext from "../../services/user/user";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

import messages_de from "../../translations/de.json";
import messages_en from "../../translations/en.json";
import messages_es from "../../translations/es.json";
import messages_fr from "../../translations/fr.json";

import img1 from "../../assets/images/plentymarkets/img1.png";
import img2_de from "../../assets/images/plentymarkets/img2_de.png";
import img2_en from "../../assets/images/plentymarkets/img2_en.png";
import img3_de from "../../assets/images/plentymarkets/img3_de.png";
import img3_en from "../../assets/images/plentymarkets/img3_en.png";
import img4_de from "../../assets/images/plentymarkets/img4_de.png";
import img4_en from "../../assets/images/plentymarkets/img4_en.png";
import img5_de from "../../assets/images/plentymarkets/img5_de.png";
import img5_en from "../../assets/images/plentymarkets/img5_en.png";
import img7 from "../../assets/images/plentymarkets/img7.png";
import img8_de from "../../assets/images/plentymarkets/img8_de.png";
import img8_en from "../../assets/images/plentymarkets/img8_en.png";
import img9 from "../../assets/images/plentymarkets/img9.png";
import img10 from "../../assets/images/plentymarkets/img10.png";
import img11_de from "../../assets/images/plentymarkets/img11_de.png";
import img11_en from "../../assets/images/plentymarkets/img11_en.png";

const pStyle = {
  fontSize: "18px",
  marginBottom: "16px"
};

export default function PlentyGuide() {
  const messages = {
    de: messages_de,
    en: messages_en,
    es: messages_es,
    fr: messages_fr
  };

  const { lang } = useContext(UserContext);

  const languageImages = useMemo(
    () => ({
      de: {
        img2: img2_de,
        img3: img3_de,
        img4: img4_de,
        img5: img5_de,
        img8: img8_de,
        img11: img11_de
      },
      en: {
        img2: img2_en,
        img3: img3_en,
        img4: img4_en,
        img5: img5_en,
        img8: img8_en,
        img11: img11_en
      }
    }),
    []
  );

  function createData(fieldName, description) {
    return { fieldName, description };
  }

  const rows = [
    createData(
      messages[lang]["plenty.table.username"],
      messages[lang]["plenty.table.username.description"]
    ),
    createData(
      messages[lang]["plenty.table.realname"],
      messages[lang]["plenty.table.realname.description"]
    ),
    createData(
      messages[lang]["plenty.table.email"],
      messages[lang]["plenty.table.email.description"]
    ),
    createData(
      messages[lang]["plenty.table.uiLanguage"],
      messages[lang]["plenty.table.uiLanguage.description"]
    ),
    createData(
      messages[lang]["plenty.table.timeZone"],
      messages[lang]["plenty.table.timeZone.description"]
    ),
    createData(
      messages[lang]["plenty.table.access"],
      messages[lang]["plenty.table.access.description"]
    ),
    createData(
      messages[lang]["plenty.table.password"],
      messages[lang]["plenty.table.password.description"]
    )
  ];

  return (
    <Box>
      <Typography component="p" sx={pStyle} className="text">
        <FormattedMessage
          id="plenty.step1"
          values={{
            b: (...chunks) => {
              return <b style={{ fontWeight: "500" }}>{chunks}</b>;
            },
            br: <br />
          }}
        />
      </Typography>
      {/* <br /> */}
      <Typography component="p" sx={pStyle} className="text">
        <FormattedMessage
          id="plenty.step2"
          values={{
            b: (...chunks) => {
              return <b style={{ fontWeight: "500" }}>{chunks}</b>;
            },
            br: <br />,
            c: (...chunks) => {
              return (
                <span
                  style={{
                    color: "white",
                    backgroundColor: "#D04039",
                    borderRadius: "100px",
                    height: "30px",
                    width: "30px",
                    display: "inline-block",
                    textAlign: "center",
                    fontSize: "18px"
                  }}
                >
                  {chunks}
                </span>
              );
            }
          }}
        />
      </Typography>
      <img
        src={img1}
        style={{ width: "100%", maxHeight: "500px", objectFit: "contain" }}
      />
      <br />
      <br />
      <Typography component="p" sx={pStyle} className="text">
        <FormattedMessage
          id="plenty.step3"
          values={{
            b: (...chunks) => {
              return <b style={{ fontWeight: "500" }}>{chunks}</b>;
            },
            br: <br />
          }}
        />
      </Typography>
      {/* TABLE */}
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell sx={{ minWidth: 180 }}>
                {messages[lang]["plenty.table.fieldName"]}
              </TableCell>
              <TableCell>
                {messages[lang]["plenty.table.description"]}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow
                key={row.fieldName}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell component="th" scope="row">
                  {row.fieldName}
                </TableCell>
                <TableCell>{row.description}</TableCell>
              </TableRow>
            ))}
            {/* <TableRow>
              <TableCell colSpan={2}>
                <FormattedMessage id="plenty.table.note" />
              </TableCell>
            </TableRow> */}
          </TableBody>
        </Table>
      </TableContainer>
      <br />
      <Typography component="p" sx={pStyle} className="text">
        <FormattedMessage
          id="plenty.step4"
          values={{
            b: (...chunks) => {
              return <b style={{ fontWeight: "500" }}>{chunks}</b>;
            },
            br: <br />
          }}
        />
      </Typography>
      <img
        src={languageImages[lang].img2}
        style={{ width: "100%", maxHeight: "500px", objectFit: "contain" }}
      />
      <br />
      <Typography component="p" sx={pStyle} className="text">
        <FormattedMessage
          id="plenty.step5"
          values={{
            b: (...chunks) => {
              return <b style={{ fontWeight: "500" }}>{chunks}</b>;
            },
            br: <br />
          }}
        />
      </Typography>
      <img
        src={languageImages[lang].img3}
        style={{ width: "100%", maxHeight: "500px", objectFit: "contain" }}
      />
      <br />
      <Typography component="p" sx={pStyle} className="text">
        <FormattedMessage
          id="plenty.step6"
          values={{
            b: (...chunks) => {
              return <b style={{ fontWeight: "500" }}>{chunks}</b>;
            },
            br: <br />
          }}
        />
      </Typography>
      <br />
      <Typography component="p" sx={pStyle} className="text">
        <FormattedMessage
          id="plenty.step7"
          values={{
            b: (...chunks) => {
              return <b style={{ fontWeight: "500" }}>{chunks}</b>;
            },
            br: <br />,
            c: (...chunks) => {
              return (
                <span
                  style={{
                    color: "white",
                    backgroundColor: "#D04039",
                    borderRadius: "100px",
                    height: "30px",
                    width: "30px",
                    display: "inline-block",
                    textAlign: "center",
                    fontSize: "18px"
                  }}
                >
                  {chunks}
                </span>
              );
            }
          }}
        />
      </Typography>
      <img
        src={languageImages[lang].img4}
        style={{ width: "100%", maxHeight: "500px", objectFit: "contain" }}
      />
      <br />
      <Typography component="p" sx={pStyle} className="text">
        <FormattedMessage
          id="plenty.step8"
          values={{
            b: (...chunks) => {
              return <b style={{ fontWeight: "500" }}>{chunks}</b>;
            },
            br: <br />
          }}
        />
      </Typography>
      <img
        src={languageImages[lang].img5}
        style={{ width: "100%", maxHeight: "500px", objectFit: "contain" }}
      />
      <br />
      <br />
      <Typography component="p" sx={pStyle} className="text">
        <FormattedMessage
          id="plenty.step9"
          values={{
            b: (...chunks) => {
              return <b style={{ fontWeight: "500" }}>{chunks}</b>;
            },
            br: <br />
          }}
        />
      </Typography>
      <img
        src={img7}
        style={{ width: "100%", maxHeight: "500px", objectFit: "contain" }}
      />
      <br />
      <br />
      <Typography component="p" sx={pStyle} className="text">
        <FormattedMessage
          id="plenty.step10"
          values={{
            b: (...chunks) => {
              return <b style={{ fontWeight: "500" }}>{chunks}</b>;
            },
            br: <br />,
            c: (...chunks) => {
              return (
                <span
                  style={{
                    color: "white",
                    backgroundColor: "#D04039",
                    borderRadius: "100px",
                    height: "30px",
                    width: "30px",
                    display: "inline-block",
                    textAlign: "center",
                    fontSize: "18px"
                  }}
                >
                  {chunks}
                </span>
              );
            }
          }}
        />
      </Typography>
      <img
        src={languageImages[lang].img8}
        style={{ width: "100%", maxHeight: "500px", objectFit: "contain" }}
      />
      <br />
      <br />

      <Typography component="p" sx={pStyle} className="text">
        <FormattedMessage
          id="plenty.step11"
          values={{
            b: (...chunks) => {
              return <b style={{ fontWeight: "500" }}>{chunks}</b>;
            },
            br: <br />
          }}
        />
      </Typography>
      <img
        src={img9}
        style={{ width: "100%", maxHeight: "500px", objectFit: "contain" }}
      />
      <br />
      <br />
      <Typography component="p" sx={pStyle} className="text">
        <FormattedMessage
          id="plenty.step12"
          values={{
            b: (...chunks) => {
              return <b style={{ fontWeight: "500" }}>{chunks}</b>;
            },
            br: <br />
          }}
        />
      </Typography>
      <img
        src={img10}
        style={{ width: "100%", maxHeight: "500px", objectFit: "contain" }}
      />
      <br />
      <br />
      <Typography component="p" sx={pStyle} className="text">
        <FormattedMessage
          id="plenty.step13"
          values={{
            b: (...chunks) => {
              return <b style={{ fontWeight: "500" }}>{chunks}</b>;
            },
            br: <br />,
            c: (...chunks) => {
              return (
                <span
                  style={{
                    color: "white",
                    backgroundColor: "#D04039",
                    borderRadius: "100px",
                    height: "30px",
                    width: "30px",
                    display: "inline-block",
                    textAlign: "center",
                    fontSize: "18px"
                  }}
                >
                  {chunks}
                </span>
              );
            }
          }}
        />
      </Typography>
      <img
        src={languageImages[lang].img11}
        style={{ width: "100%", maxHeight: "500px", objectFit: "contain" }}
      />
    </Box>
  );
}
